<template>
  <!-- 员工管理 -->
  <div class="page-staff-person">
    <div class="wrap">
      <cmpTree ref="cmpTree" @getKey="getKey" @refresh="initList" @resetEvent="resetEvent" :treeData="treeData" :lightKey="listQuery.partyDept"></cmpTree>

      <div class="content com-right pdl-30">
        <h1 class="title">
          {{headTitle}}
          <div class="title-r fr">
            <!-- <el-button class="el-primary-border mr-30" @click="addStaff('add')">
              <svg-icon icon-class="add" />&nbsp;新增在职员工
            </el-button> -->

            <el-input style="width:250px;" placeholder="请输入姓名或手机号搜索" @keyup.enter.native="searchList" v-model="listQuery.phone">
              <i slot="suffix" class="el-icon-search g-pointer" @click="searchList"></i>
            </el-input>
          </div>
        </h1>
        <!-- 表格 -->
        <div class="table mt-20">
          <el-table stripe :data="tableData" v-loading="listLoading">
            <!-- <el-table-column type="selection" width="42" :reserve-selection="true"></el-table-column> -->
            <el-table-column prop="userName" label="用户名" min-width="15%"></el-table-column>
            <el-table-column prop="userName" label="姓名" min-width="15%"></el-table-column>
            <el-table-column prop="phone" label="手机号码" min-width="20%"></el-table-column>
            <el-table-column prop="deptName" label="所属部门" show-overflow-tooltip min-width="15%"></el-table-column>
            <el-table-column prop="txtStatus" label="账号状态" min-width="15%">
              <template slot-scope="scope">
                <!-- 1：启用，2：停用-->
                <span class="m-dot-box" :class="{
                'm-danger': scope.row.userStatus==='2',
                'm-info': scope.row.userStatus==='1' }">
                  <i class="m-circle-dot"></i>
                  {{ scope.row.txtStatus }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="lastLoginStr" label="上次登录时间" min-width="18%"></el-table-column>

            <!-- <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-dropdown trigger="click" @command="handleOperate(scope.row, $event)">
                  <span>
                    <svg-icon icon-class="more" class-name="icon-common g-pointer" style="font-size: 12px;color:#575962;transform: rotate(90deg);" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">查看详情</el-dropdown-item>
                    <el-dropdown-item command="2">编辑资料</el-dropdown-item>
                    <el-dropdown-item command="3">重置密码</el-dropdown-item>
                    <el-dropdown-item command="4">{{scope.row.userStatus === '1' ? '停用账号' : '启用账号'}}</el-dropdown-item>
                    <el-dropdown-item command="5">删除账号</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="pagination-container">
            <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
    </div>

    <dialogAddStaff ref="dialogAddStaff" :bussinessType="`staff`" :staffType="'party'" @refresh="initList"></dialogAddStaff>
    <dialogEditPasswd ref="dialogEditPasswd" @refresh="initList"></dialogEditPasswd>
  </div>
</template>

<script>
import cmpTree from '@cmp/tree'
import dialogAddStaff from './../dialog-add-staff'
import dialogEditPasswd from './dialog-edit-passwd'

export default {
  components: { cmpTree, dialogAddStaff, dialogEditPasswd },
  data() {
    return {
      treeData: [],
      tableData: [],
      listLoading: true,
      listQuery: {
        partyDept: '', // 部门id
        phone: '', // 手机号或姓名
        currentPage: 1,
        size: 10
      },
      total: 0,
      headTitle: ''
    }
  },
  methods: {
    // 初始化表格
    initList() {
      this.$http.get('/deptree/list', { type: 1 }).then(res => {
        if (res.success) {
          if (res.result && res.result.length >= 2) {
            let tempArr = []
            tempArr.push(res.result[1])
            this.treeData = tempArr
            !this.listQuery.partyDept && (this.listQuery.partyDept = res.result[1].id)
            !this.headTitle && (this.headTitle = res.result[1].label)
            // this.listQuery.partyDept = res.result[0].id
            this.getDataList()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    resetEvent() {
      this.listQuery.partyDept = ''
      this.headTitle = ''
      this.initList()
    },
    getDataList(type) {
      this.listLoading = true
      this.$http
        .get('/user/listEmployee', {
          type: 2,
          ...this.listQuery
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (
              type === 'dele' &&
              this.listQuery.currentPage > 1 &&
              !res.result.length
            ) {
              this.listQuery.currentPage -= 1
              this.initList()
              return
            }
            this.tableData = res.result
            this.total = res.page.allRow
            this.listLoading = false
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 搜索
    searchList() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    getKey(data) {
      this.headTitle = data.label
      this.listQuery.partyDept = data.id
      this.searchList()
    },
    // 点击菜单面板
    handleOperate(data, type) {
      switch (type) {
        // 查看详情
        case '1':
          this.addStaff('detail', data.userId)
          break
        // 编辑资料
        case '2':
          this.addStaff('edit', data.userId)
          break
        // 重置密码
        case '3':
          this.$refs.dialogEditPasswd.init(data, 'reset')
          break
        // 停用账号 // 1：启用，2：停用
        case '4':
          if (data.userStatus === '1') {
            this.$refs.dialogEditPasswd.init(data, 'stop')
          } else {
            this.openUser(data)
          }
          break
        // 删除账号
        case '5':
          this.dele(data.userId)
          break
      }
    },
    // 启用账号
    openUser(data) {
      this.$http
        .post('/user/updateEmployee', {
          userId: data.userId,
          userStatus: '1' // 1：启用，2：停用
        })
        .then(res => {
          this.loadingSave = false
          if (res.success) {
            this.$message.success('启用账号成功')
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 新增、编辑在职员工
    addStaff(type, id) {
      this.$refs.dialogAddStaff.init(type, id)
    },
    dele(id) {
      this.$common.confirm(
        {
          title: '删除账号后，该员工数据将一并删除，且不可恢复，请谨慎操作',
          className: 'cus-confirm-375'
        },
        () => {
          console.log('删除')
          this.$http
            .get('/user/deleteEmployee', {
              id: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('删除员工成功')
                this.getDataList('dele')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  },
  created() {
    this.initList()
  }
}
</script>

<style lang="scss" scoped>
.page-staff-person {
  height: 100%;
  .wrap {
    display: flex;
    // padding: 0 30px;
    padding-left: 10px;
    border-radius: 4px;
    box-shadow: 0px 1px 10px 0px rgba(238, 239, 245, 1);
    background: #fff;
    height: 100%;
  }
  .cmp-tree {
    padding-top: 20px;
  }
  .com-right {
    padding: 30px;
    flex: 1;
    overflow: hidden;
    border-left: solid 1px $border;
  }
  .title {
    position: relative;
    // .btn-add {
    //   position: absolute;
    // }
  }
}
</style>


